import { InformationIcon } from '@atgfr8/icons';

import { OnHoverPopover } from './OnHoverPopover';

type Props = {
  id: number;
  title: string;
  body: string;
  htmlColor?: string;
};

export const InfoIcon = (props: Props) => {
  return (
    <OnHoverPopover
      id={`info-popover-${props.id}`}
      title={props.title}
      body={props.body}
      htmlColor={props.htmlColor}
    >
      <InformationIcon
        size={20}
        color={props.htmlColor ?? 'rgba(0, 0, 0, 0.56)'}
      />
    </OnHoverPopover>
  );
};
